module.exports = "<span>{{formattedDate}}</span>\n"